import { useCallback } from 'react';
import Config from '../Config';
import RequestRabbit from './RequestRabbit';

// const handleRequest = new RequestRabbit();

const useCostCentreRequest = () => {
  const getCentres = useCallback(async (errorHandler) => {
    try {
      const url = `${Config.baseServerURL}/centre/`;
      let response = await RequestRabbit.request(
        url,
        { method: 'GET' },
        errorHandler
      );
      return await response?.json();
    } catch (e) {
      errorHandler(e.message);
    }
  }, []);

  const createCostCentre = useCallback(async (data, errorHandler) => {
    try {
      const url = `${Config.baseServerURL}/centre/`;
      let response = await RequestRabbit.request(
        url,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        },
        errorHandler
      );
      return await response?.json();
    } catch (e) {
      errorHandler(e.message);
    }
  }, []);

  const editCostCentre = useCallback(
    async (costCentreId, edits, errorHandler) => {
      try {
        const url = `${Config.baseServerURL}/centre/${costCentreId}`;
        let response = await RequestRabbit.request(
          url,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(edits),
          },
          errorHandler
        );
        return await response?.json();
      } catch (e) {
        errorHandler(e.message);
      }
    },
    []
  );

  const deleteCostCentre = useCallback(async (costCentreId, errorHandler) => {
    try {
      const url = `${Config.baseServerURL}/centre/${costCentreId}`;
      await RequestRabbit.request(url, { method: 'DELETE' }, errorHandler);
    } catch (e) {
      errorHandler(e.message);
    }
  }, []);

  const getUsersForCostCentre = useCallback(
    async (costCentreId, errorHandler) => {
      try {
        const url = `${Config.baseServerURL}/centre/${costCentreId}/users`;
        let response = await RequestRabbit.request(
          url,
          { method: 'GET' },
          errorHandler
        );
        return await response?.json();
      } catch (e) {
        errorHandler(e.message);
      }
    },
    []
  );

  return {
    getCentres,
    createCostCentre,
    editCostCentre,
    deleteCostCentre,
    getUsersForCostCentre,
  };
};

export default useCostCentreRequest;
